import { Component, OnDestroy, OnInit } from "@angular/core";
import { ToastrManager } from "ng6-toastr-notifications";
import { Validators, FormGroup, FormBuilder } from "@angular/forms";
import { SharedService } from "src/app/shared/Services/shared.service";
import { CoreService } from "../../Services/core.service";
import { TitleService } from 'src/app/shared/Services/title.service';
import { JwtService } from "src/app/shared/Services/jwt.service";
import { AuthService } from "src/app/shared/Services/auth.service";
import { ActivatedRoute, Router } from "@angular/router";
import { StorageService } from "src/app/shared/Services/storage.service";
import { LoggingService } from "src/app/shared/Services/NGLogger/logging-service.service";
import { Subject, catchError, of, takeUntil, tap } from "rxjs";

@Component({
  selector: "app-change-password",
  templateUrl: "./change-password.component.html",
  styleUrls: ["./change-password.component.css"],
})
export class ChangePasswordComponent implements OnInit, OnDestroy {
  private componentDestroyed$: Subject<void> = new Subject(); // For unsubscribing when the component is destroyed
  changePaswordForm!: FormGroup;
  notMatch!: boolean;
  Profilelist: any;
  submited: boolean = false;
  Id: any;
  public showPasswordC: boolean = false;
  public showPasswordO: boolean = false;
  public showPasswordN: boolean = false;
  constructor(
    private formBuilder: FormBuilder,
    private coreServices: CoreService,
    private toastr: ToastrManager,
    private shareservice: SharedService,
    private _titleService: TitleService,
    private jwtService: JwtService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private storageService: StorageService,
    private loggingService: LoggingService
  ) {
    var newTitle = 'Change Password';
    this._titleService.setTitle(newTitle);
    this.forminit();
  }

  ngOnDestroy(): void { }

  ngOnInit(): void { }

  forminit() {
    this.changePaswordForm = this.formBuilder.group({
      oldPassword: [
        "",
        [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(
            "(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-zd$@$!%*?&].{7,}"
          ),
        ],
      ],
      newPassword: [
        "",
        [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(
            "(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-zd$@$!%*?&].{7,}"
          ),
        ],
      ],
      confirmPassword: [
        "",
        [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(
            "(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-zd$@$!%*?&].{7,}"
          ),
        ],
      ],
      Id: [this.Id, [Validators.required]],
    });
  }

  changePasswordForm() {

    const passwordPattern =
      "(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-zd$@$!%*?&].{7,}";
    const validators = [
      Validators.required,
      Validators.minLength(6),
      Validators.pattern(passwordPattern),
    ];

    this.changePaswordForm = this.formBuilder.group({
      oldPassword: ["", validators],
      newPassword: ["", validators],
      confirmPassword: ["", validators],
      updatedDate: [""],
    });

    this.resetErrors();

    this.notMatch = false;
  }

  resetErrors() {
    const controls = ["oldPassword", "newPassword", "confirmPassword"];

    controls.forEach((control) => {
      this.changePaswordForm.controls[control].setErrors({ invalid: false });
    });
  }

  onSubmit() {
    this.authService.jwtTokenExpCheck();
    this.submited = true;

    const newPassword = this.changePaswordForm.controls["newPassword"].value;
    const confirmPassword =
      this.changePaswordForm.controls["confirmPassword"].value;

    if (newPassword === confirmPassword) {
      this.notMatch = false;

      if (this.changePaswordForm.valid) {
        try {
          this.updatePassword();
        } catch (error) {
          this.loggingService.captureException(error);
          throw error;
        }

      } else {
        return false;
      }
    } else {
      this.notMatch = true;
      return false;
    }
    return false;
  }

  updatePassword() {
    try {

      this.coreServices
        .changePassword(this.changePaswordForm.value)
        .pipe(tap((res: any) => {
          if (res.succeeded) {
            this.clearData();
            this.toastr.successToastr(res.messages[0], "Done!");
            this.storageService.clean();
            this.storageService.removeLocalStorage();
            this.router.navigate(['/']).then(() =>
              window.location.reload()
            );
          } else {
            this.toastr.errorToastr(res.messages[0], "", "top-right");
          }
        }),
          catchError((error) =>{
            this.loggingService.captureException(error);
            return of(null);
          }),
          takeUntil(this.componentDestroyed$)
          )
          .subscribe();
    } catch (error) {
      this.loggingService.captureException(error);
    }
  }

  clearData() {
    this.changePaswordForm.reset();
    this.submited = false;
    this.notMatch = false;
  }

  public togglePasswordVisibilityC(): void {
    this.showPasswordC = !this.showPasswordC;
  }

  public togglePasswordVisibilityN(): void {
    this.showPasswordN = !this.showPasswordN;
  }

  public togglePasswordVisibilityO(): void {
    this.showPasswordO = !this.showPasswordO;
  }
}
